import { ThemedText } from "@/components/themed-text";
import { styles } from "@/styles/onboarding";
import Ionicons from "@react-native-vector-icons/ionicons";
import { Image } from "expo-image";
import { LinearGradient } from "expo-linear-gradient";
import React from "react";
import { ImageSourcePropType, TouchableOpacity, View } from "react-native";
import { useSafeAreaInsets } from "react-native-safe-area-context";

interface OnboardingProps {
  image: ImageSourcePropType;
  title: string;
  description: string;
  buttonText?: string;
  onButtonPress: () => void;
  onBackPress?: () => void;
  step: number;
  totalSteps: number;
}

export default function Onboarding({
  image,
  title,
  description,
  buttonText = "Next",
  onButtonPress,
  onBackPress,
  step,
  totalSteps,
}: OnboardingProps) {
  const insets = useSafeAreaInsets();
  const activeDot = step - 1;

  return (
    <View style={styles.container}>
      <Image source={image} style={styles.image} />
      <LinearGradient
        colors={[
          "rgba(3, 134, 150, 0)",
          "rgba(2, 107, 120, 0.05)",
          "rgba(2, 79, 88, 0.4)",
          "rgba(1, 43, 48, 1)",
        ]}
        locations={[0, 0.1, 0.23, 0.8]}
        style={styles.gradientOverlay}
      >
        <View
          style={[styles.bottomSheet, { paddingBottom: insets.bottom + 24 }]}
        >
          <View style={styles.textContainer}>
            <View style={styles.stepBadge}>
              <ThemedText style={styles.stepBadgeText}>
                {step}/{totalSteps}
              </ThemedText>
            </View>

            <ThemedText style={styles.title} type="title">
              {title}
            </ThemedText>

            <ThemedText style={styles.subtitle} type="subtitle">
              {description}
            </ThemedText>

            <View style={styles.pagination}>
              {Array.from({ length: totalSteps }).map((_, index) => (
                <View
                  key={index}
                  style={[styles.dot, index === activeDot && styles.activeDot]}
                />
              ))}
            </View>
          </View>

          <View style={[styles.navRow, !onBackPress && styles.navRowAlone]}>
            {onBackPress && (
              <TouchableOpacity
                onPress={onBackPress}
                style={styles.backButton}
                accessibilityRole="button"
                accessibilityLabel="Go back"
              >
                <Ionicons name="chevron-back" size={22} color="#fff" />
              </TouchableOpacity>
            )}

            <TouchableOpacity
              onPress={onButtonPress}
              style={styles.nextButton}
              accessibilityRole="button"
              accessibilityLabel={buttonText}
            >
              <ThemedText style={styles.buttonText} type="defaultSemiBold">
                {buttonText}
              </ThemedText>
            </TouchableOpacity>
          </View>
        </View>
      </LinearGradient>
    </View>
  );
}
